import { Injectable } from '@angular/core';
import { CONFIG } from '../../shared/config';
import { HttpGeneralService } from '../../shared';
const LoyaltyPointsRedemptionPolicyUrl = CONFIG.baseUrls.LoyaltyPointsRedemptionPolicy;


export interface LoyaltyPointsRedemptionPolicy {
  serial: number;
  countOfPoints: number;
  pointsValue: number;
  valueOfPoints: number;
  discountReason: number;
  dataStatus: number;

}

@Injectable({
  providedIn: 'root'
})

export class LoyaltyPointsRedemptionPolicyService {
  constructor(private httpGeneralService: HttpGeneralService) { }

  postLoyaltyPointsRedemptionPolicy(LoyaltyPointsRedemptionPolicy: LoyaltyPointsRedemptionPolicy) {
    return this.httpGeneralService.post(LoyaltyPointsRedemptionPolicy, `${LoyaltyPointsRedemptionPolicyUrl}/postLoyaltyPointsRedemptionPolicy`);
  }

  getLoyaltyPointsRedemptionPolicy(LoyaltyPointsRedemptionPolicy: LoyaltyPointsRedemptionPolicy) {
    return this.httpGeneralService.post(LoyaltyPointsRedemptionPolicy, `${LoyaltyPointsRedemptionPolicyUrl}/getLoyaltyPointsRedemptionPolicy`);
  }
  deleteLoyaltyPointsRedemptionPolicy(code: number) {
    return this.httpGeneralService.delete(code, `${LoyaltyPointsRedemptionPolicyUrl}/deleteLoyaltyPointsRedemptionPolicy`);
  }


}
